import keyMirror from 'keymirror-nested'

export default keyMirror({
  BOL: {
    UPDATE: null,
  },
})
